import * as types from './types';

export default {
  fetchSystems: (payload) => ({ type: types.FETCH_SYSTEMS, payload }),
  fetchDiagrams: (payload) => ({ type: types.FETCH_DIAGRAMS, payload }),
  fetchIcons: (payload) => ({ type: types.FETCH_ICONS, payload }),
};
